<template>
  <div
    class="tip-root ant-tooltip yxt-tooltip__popper is-dark"
    :data-placement="placement"
    :style="{display, left, top}"
  >
    <div v-html="msg"></div>
    <div class="arrow"></div>
  </div>
</template>
<script>

export default {
  name: 'AntTooltip',

  data() {
    return {
      display: 'none',
      placement: 'top',
      msg: 'xx',
      left: '0px',
      top: '0px'
    };
  },
  beforeCreate() {

  },
  mounted() {
    console.debug('mounted');
  },
  methods: {
    isShow() {
      return this.display === 'block';
    },
    show(v) {
      const { msg, x, y, placement } = v;
      this.msg = msg;
      this.left = `${x}px`;
      this.top = `${y}px`;
      this.display = 'block';
      if (placement) {
        this.placement = placement;
      }
    },
    hide() {
      this.display = 'none';
    },
    isOverflow() {
      return this.$el.scrollWidth <= this.$el.clientWidth && this.$el.scrollHeight <= this.$el.clientHeight;
    }
  },
  destroyed() {
    console.debug('destroyed');
  }
};
</script>
<style scoped>
.tip-root{
  position: absolute;
}
.tip-root[data-placement="top"] {
  transform: translate(-50%, calc(-100% - 15px));
}
.tip-root[data-placement="right"] {
  transform: translate(15px, calc(-50%));
}
.tip-root .arrow::after {
  content: " ";
  border-width: 5px;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.tip-root[data-placement="top"] .arrow::after{
  left: 50%;
  transform: translate(-10px, 6px);
  border-top: 5px solid rgba(38,38,38,.9);
}
.tip-root[data-placement="right"] .arrow::after{
  top: 50%;
  transform: translate(-17px, -50%);
  border-right: 5px solid rgba(38,38,38,.9);
}
</style>
